import React from 'react'
//import Logo from '../Components/Logo/Logo'
import SideBar from '../Components/SIdeBar/SideBar'
import './SideSection.css'

const SideSection = props => {
  return (
    <div onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} className={`sidebar ${props.addClass}`}>
  {/*<Logo/>*/}
    <SideBar/>
    </div>
  )
}
export default SideSection